import { KsService, useApiClient } from '@siclop/kstone-vue'
import type { ProjectType } from '../models'

export class ProjectTypeService extends KsService {
  protected static mainUrl = '/project-types'

  /**
   * Get all active project types
   */
  static async getActiveTypes(): Promise<ProjectType[]> {
    const client = useApiClient()
    return await client.getAll<ProjectType>(`${this.mainUrl}/active`)
  }

  /**
   * Get project type by code
   */
  static async getByCode(code: string): Promise<ProjectType | null> {
    const client = useApiClient()
    return await client.get<ProjectType>(`${this.mainUrl}/code/${code}`) ?? null
  }

  /**
   * Get project type with estimation scales
   */
  static async getWithScales(id: number): Promise<ProjectType | null> {
    const client = useApiClient()
    return await client.get<ProjectType>(`${this.mainUrl}/${id}/with-scales`) ?? null
  }

  /**
   * Toggle active status
   */
  static async toggleActive(id: number): Promise<ProjectType> {
    const client = useApiClient()
    const axios = client.getAxiosInstance()
    const response = await axios.patch<ProjectType>(`${this.mainUrl}/${id}/toggle-active`)
    return response.data
  }

  /**
   * Remplace les abaques du type, dans l'ordre donné, et rend le type à jour (même route que les types de
   * fonctionnalité, T19)
   */
  static async updateScales(id: number, estimationScaleIds: number[]): Promise<ProjectType> {
    const client = useApiClient()
    const axios = client.getAxiosInstance()
    const response = await axios.put<ProjectType>(`${this.mainUrl}/${id}/scales`, estimationScaleIds)
    return response.data
  }

  /**
   * Save project type with its estimation scales in a single operation
   * Avoids multiple updates and reduces UI flickering
   */
  static async saveWithScales(model: Partial<ProjectType>): Promise<ProjectType> {
    const client = useApiClient()
    const axios = client.getAxiosInstance()
    const response = await axios.post<ProjectType>(`${this.mainUrl}/with-scales`, model)
    return response.data
  }
}
